import {
  AVRAM_YZER_ID,
  HAVATZELET_YZER_ID,
  HOLON_YZER_ID,
  SHVIRO_YZER_ID,
  YUVALIM_YZER_ID,
  RASSCO_YZER_ID,
  RASSCO_NEW_YZER_ID,
  PISGAT_YZER_ID,
  SHBIRO_NEVE_ZEMER_YZER_ID,
} from './constants';
import { pannellumConfigShviro } from './shviro/pannellum';
import { pannellumConfigAvram } from './avram/pannellum';
import { pannellumConfigHolon } from './holon/pannellum';
import { inventoryDataShviro } from './shviro/inventory-data';
import { inventoryDataAvram } from './avram/inventory-data';
import { inventoryDataHolon } from './holon/inventory-data';
import { pannellumConfigHavatzelet } from './havatzelet/pannellum';
import { inventoryDataHavatzelet } from './havatzelet/inventory-data';
import { pannellumConfigYuvalim } from './yuvalim/pannellum';
import { inventoryDataYuvalim } from './yuvalim/inventory-data';
import { pannellumConfigRassco } from './rassco/pannellum';
import { inventoryDataRassco } from './rassco/inventory-data';
import { pannellumConfigPisgat } from './pisgat/pannellum';
import { inventoryDataPisgat } from './pisgat/inventory-data';
import { pannellumConfigShbiroNeveZemer } from './shbiro-neve-zemer/pannellum';
import { inventoryDataShbiroNeveZemer } from './shbiro-neve-zemer/inventory-data';

import type { TProject } from '../types/config';

export const gallerySizes = {
  m2_a: 15,
  m2_b: 13,
  m2_d: 15,
  m3_a: 15,
  m3_b: 13,
  m3_d: 15,
  s1_a: 18,
  s1_c: 26,
  s1_d: 13,
  s1_f: 22,
  s2_a: 18,
  s2_c: 26,
  s2_d: 15,
  s2_f: 22,
  s3_a: 18,
  s3_c: 26,
  s3_d: 13,
  s3_f: 22,
  s4_a: 18,
  s4_c: 26,
  s4_d: 13,
  s4_f: 22,
  s5_a: 18,
  s5_c: 26,
  s5_d: 13,
  s5_f: 22,
  s6_a: 18,
  s6_c: 26,
  s6_d: 13,
  s6_f: 22,
};

export const pannellumConfigs = {
  [SHVIRO_YZER_ID]: pannellumConfigShviro,
  [AVRAM_YZER_ID]: pannellumConfigAvram,
  [HOLON_YZER_ID]: pannellumConfigHolon,
  [HAVATZELET_YZER_ID]: pannellumConfigHavatzelet,
  [YUVALIM_YZER_ID]: pannellumConfigYuvalim,
  [RASSCO_YZER_ID]: pannellumConfigRassco,
  [RASSCO_NEW_YZER_ID]: pannellumConfigRassco,
  [PISGAT_YZER_ID]: pannellumConfigPisgat,
  [SHBIRO_NEVE_ZEMER_YZER_ID]: pannellumConfigShbiroNeveZemer,
};

export const inventoryConfigs = {
  [SHVIRO_YZER_ID]: inventoryDataShviro,
  [AVRAM_YZER_ID]: inventoryDataAvram,
  [HOLON_YZER_ID]: inventoryDataHolon,
  [HAVATZELET_YZER_ID]: inventoryDataHavatzelet,
  [YUVALIM_YZER_ID]: inventoryDataYuvalim,
  [RASSCO_YZER_ID]: inventoryDataRassco,
  [RASSCO_NEW_YZER_ID]: inventoryDataRassco,
  [PISGAT_YZER_ID]: inventoryDataPisgat,
  [SHBIRO_NEVE_ZEMER_YZER_ID]: inventoryDataShbiroNeveZemer,
};

export const mapYzerIdToAwsProject = {
  [SHVIRO_YZER_ID]: 'shviro',
  [AVRAM_YZER_ID]: 'avram',
  [HOLON_YZER_ID]: 'holon',
  [HAVATZELET_YZER_ID]: 'havatzelet',
  [YUVALIM_YZER_ID]: 'yuvalim',
  [RASSCO_YZER_ID]: 'rassco',
  [RASSCO_NEW_YZER_ID]: 'rassco',
  [PISGAT_YZER_ID]: 'pisgat',
  [SHBIRO_NEVE_ZEMER_YZER_ID]: 'shbiro-neve-zemer',
};

// Backward-compatible alias
export const mapYad2IdToAwsProject = mapYzerIdToAwsProject;

export const yzerFullProjects = [
  SHVIRO_YZER_ID,
  AVRAM_YZER_ID,
  HOLON_YZER_ID,
  HAVATZELET_YZER_ID,
  YUVALIM_YZER_ID,
  RASSCO_YZER_ID,
  RASSCO_NEW_YZER_ID,
  PISGAT_YZER_ID,
  SHBIRO_NEVE_ZEMER_YZER_ID,
];

export function hasPanoramaForProject(project: TProject): boolean {
  return yzerFullProjects.includes(project.yzerId) || !!project.panoramaXmlPath;
}

export function getAwsFolderForProject(project: Pick<TProject, 'yzerId'>): string | undefined {
  return mapYzerIdToAwsProject[project.yzerId as keyof typeof mapYzerIdToAwsProject];
}

// Backward-compatible alias
export const yadFullProjects = yzerFullProjects;
